import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { POSTS } from '../data/content.js'

export default function BlogPost() {
  const { slug } = useParams()
  const { t } = useTranslation()
  const post = POSTS.find((p) => p.slug === slug)

  if (!post) {
    return <div className="container section" style={{ color: 'var(--muted)' }}>{t('blog.notFound')}</div>
  }

  const item = t(`blogItems.${post.id}`, { returnObjects: true })

  return (
    <article className="section">
      <div className="container">
        <p className="eyebrow"><Link to="/blog">← {t('blog.title')}</Link></p>
        <h1 className="section-title">{item.title}</h1>
        <div className="post-content">{item.content}</div>
      </div>
    </article>
  )
}